class WelluviLoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-load-more-button]');
    this.progress = this.querySelector('[data-load-more-progress]');
    this.count = this.querySelector('[data-load-more-count]');
    this.button?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }

  handleClick = async () => {
    if (!this.button || this.button.disabled) return;

    const nextUrl = this.dataset.nextUrl;
    const sectionId = this.dataset.sectionId;
    if (!nextUrl || !sectionId) return;

    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    const originalLabel = this.button.textContent;
    this.button.textContent = 'Loading…';

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(`Load more failed: ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incomingGrid = doc.querySelector('[data-testid="product-grid"]');
      const currentGrid = this.closest('results-list')?.querySelector('[data-testid="product-grid"]');

      if (!incomingGrid || !currentGrid) throw new Error('Product grid not found in response');

      const existingIds = new Set(
        [...currentGrid.querySelectorAll('[data-product-id]')].map((item) => item.getAttribute('data-product-id'))
      );

      const incomingItems = [...incomingGrid.querySelectorAll(':scope > [data-product-id]')].filter(
        (item) => !existingIds.has(item.getAttribute('data-product-id'))
      );

      currentGrid.append(...incomingItems);

      const incomingControl = doc.querySelector('welluvi-load-more');
      if (incomingControl) {
        this.dataset.nextUrl = incomingControl.dataset.nextUrl || '';
        this.dataset.viewed = incomingControl.dataset.viewed || this.dataset.viewed;
        this.dataset.total = incomingControl.dataset.total || this.dataset.total;
      } else {
        this.dataset.nextUrl = '';
        this.dataset.viewed = this.dataset.total;
      }

      this.updateUi();

      const page = new URL(nextUrl, window.location.origin).searchParams.get('page');
      if (page) {
        const browserUrl = new URL(window.location.href);
        browserUrl.searchParams.set('page', page);
        history.replaceState({}, '', browserUrl.toString());
      }
    } catch (error) {
      console.error('[Welluvi] Load more error', error);
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
      this.button.textContent = originalLabel || 'Load More';
    }
  };

  updateUi() {
    const viewed = Number(this.dataset.viewed || 0);
    const total = Number(this.dataset.total || 0);
    const percentage = total > 0 ? Math.min(100, Math.round((viewed / total) * 100)) : 100;

    if (this.count) this.count.textContent = `You've viewed ${viewed} of ${total} products`;
    if (this.progress) this.progress.style.setProperty('--welluvi-progress', `${percentage}%`);

    if (!this.dataset.nextUrl || viewed >= total) {
      this.button?.remove();
      this.setAttribute('data-complete', 'true');
    } else if (this.button) {
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
      this.button.textContent = 'Load More';
    }
  }
}

if (!customElements.get('welluvi-load-more')) {
  customElements.define('welluvi-load-more', WelluviLoadMore);
}
